
<template>
  <div>
    <ul class="nav nav-tabs" role="tablist" :id="'nav-tabs-' + id">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" :href="'#graph-' + id" :id="'tab-graph-' + id">Graph</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" :href="'#table-' + id" :id="'tab-table-' + id">Table</a>
      </li>
    </ul>
    <div class="tab-content" :id="'tab-content-' + id">
      <div class="tab-pane fade show active" role="tabpanel" :id="'graph-' + id">
        <div class="chart-container" :id="'chart-container-' + id">
          <canvas ref="canvas"></canvas>
        </div>
      </div>
      <div class="tab-pane fade table-responsive" role="tabpanel" :id="'table-' + id">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th></th>
              <th v-for="header in tableHeaders" :key="header.label">{{ header.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in tableRows" :key="row.label">
              <td>{{ row.label }}</td>
              <td v-for="(value,index) in row.data" :key="index">{{ value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement, LineController } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement, LineController);

export default {
  name: 'LineGraph',
  
  created() {
    
  },
  
  data() {
    return {
      id: Math.random().toString(36).substring(2,15),
    }
  },
  
  props: {
   chartData: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      required: true
    }
  },

  computed: {
    tableRows() {
      return this.chartData.datasets.map(dataset => {
        return {
          label: dataset.label,
          data: dataset.data.length < 12 ? [...dataset.data, ...Array(12 - dataset.data.length).fill('')] : dataset.data
        }
      })
    },
    tableHeaders() {
      return this.chartData.labels.map(label => {
        return {
          label: label
        }
      })
    }
 },

  mounted() {
    this.renderChart();
  },

  watch: {
    chartData: {
      handler() {
        this.renderChart();
      },
      deep: true
    },
    chartOptions: {
      handler() {
        this.renderChart();
      },
      deep: true
    }
  },

  methods: {
    renderChart() {
      if (this.chartData && this.chartData.labels && this.chartData.labels.length > 0) {
        this.$nextTick(() => {
          const ctx = this.$refs.canvas.getContext('2d');
          
          // Destroy existing chart if it exists
          if (this.$data._chart) {
            this.$data._chart.destroy();
          }

          // Create the line chart
          this.$data._chart = new ChartJS(ctx, {
            type: 'line',
            data: this.chartData,
            options: this.chartOptions
          });
        });
      }
    }
  },


}
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 400px;
  width: 100%;
}
</style>
